import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../data/loading-cdm.json'; // Ensure you have a Lottie JSON file here

const Loading = () => {
    return (
        <div style={styles.container}>
            <Lottie animationData={loadingAnimation} loop={true} style={styles.animation} />
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f9f9f9',
    },
    animation: {
        width: 150,
        height: 150,
    },
};

export default Loading;